import {useMutation, useQueryClient} from '@tanstack/react-query';
import contractUpdaters from '@/api/updaters/contracts';
import {CAMPAIGN_V2_CREATORS_COUNTS_BASE_QUERY_KEY} from '@/hooks/queries/use-campaign-v2-creators-counts-query';

function useCancelContract() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['contracts', 'cancel'],
    mutationFn: contractUpdaters.cancel,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['campaignV2Creators']});
      queryClient.invalidateQueries({
        queryKey: [CAMPAIGN_V2_CREATORS_COUNTS_BASE_QUERY_KEY],
      });
    },
  });
}

export default useCancelContract;
